// Finance shell — Night Audit · Balances Due · Invoice Register · Settings.
import React, { useEffect, useState } from 'react';
import { Landmark, Moon, Receipt, Settings, ShieldCheck, Wallet } from 'lucide-react';
import NightAuditTab from './NightAuditTab';
import BalancesTab from './BalancesTab';
import InvoiceRegisterTab from './InvoiceRegisterTab';
import FinanceSettingsTab from './FinanceSettingsTab';
import FiscalSettingsPanel from './FiscalSettingsPanel';
import FiscalDailyReport from './FiscalDailyReport';

const TABS = [
  { k: 'audit', label: 'Night Audit', icon: Moon, roles: ['super_admin', 'admin', 'manager', 'reception', 'accountant'] },
  { k: 'balances', label: 'Balances Due', icon: Wallet, roles: ['super_admin', 'admin', 'manager', 'reception', 'accountant'] },
  { k: 'invoices', label: 'Invoice Register', icon: Receipt, roles: ['super_admin', 'admin', 'manager', 'accountant'] },
  { k: 'fiscal', label: 'Fiscal Day', icon: ShieldCheck, roles: ['super_admin', 'admin', 'manager', 'reception', 'accountant'] },
  { k: 'settings', label: 'Settings', icon: Settings, roles: ['super_admin', 'admin', 'manager'] },
];

const FinanceDashboard = ({ userRole, initialTab, initialQuery }) => {
  const visible = TABS.filter((t) => t.roles.includes(userRole));
  const [tab, setTab] = useState(() => (initialTab && visible.some((t) => t.k === initialTab) ? initialTab : visible[0]?.k || 'audit'));
  useEffect(() => { if (initialTab && visible.some((t) => t.k === initialTab)) setTab(initialTab); }, [initialTab]); // eslint-disable-line react-hooks/exhaustive-deps
  const canRun = ['super_admin', 'admin', 'manager', 'reception'].includes(userRole);
  const canManage = ['super_admin', 'admin', 'manager'].includes(userRole);

  const tabBtns = visible.map(({ k, label, icon: Icon }) => (
    <button
      key={k}
      onClick={() => setTab(k)}
      className={`flex-1 py-2 px-2 rounded-lg text-sm font-semibold flex items-center justify-center gap-2 whitespace-nowrap transition-colors ${
        tab === k ? 'bg-slate-900 text-white' : 'text-slate-700 hover:bg-slate-100'
      }`}
      data-testid={`finance-tab-${k}`}
    >
      <Icon className="w-4 h-4" /> {label}
    </button>
  ));

  return (
    <div className="space-y-4" data-testid="finance-dashboard">
      <div className="bg-white rounded-xl border p-4">
        <h2 className="font-bold text-slate-900 flex items-center gap-2">
          <Landmark className="w-5 h-5 text-orange-500" /> Finance &amp; Night Audit
        </h2>
        <p className="text-xs text-slate-500 mt-1">
          Close the business day, post room nights, catch no-shows and unpaid folios, and keep a legal invoice register.
        </p>
      </div>
      <div className="flex gap-2 bg-white rounded-xl border p-1 overflow-x-auto">{tabBtns}</div>
      {tab === 'audit' && <NightAuditTab canRun={canRun} canManage={canManage} />}
      {tab === 'balances' && <BalancesTab />}
      {tab === 'invoices' && <InvoiceRegisterTab initialQ={initialQuery} userRole={userRole} />}
      {tab === 'fiscal' && <FiscalDailyReport userRole={userRole} />}
      {tab === 'settings' && <><FiscalSettingsPanel canManage={['super_admin', 'admin'].includes(userRole)} /><FinanceSettingsTab /></>}
    </div>
  );
};

export default FinanceDashboard;
